module.exports = __webpack_public_path__ + "b9b49e04f9244a6d0f5673d2937d4458.glb";